import '../styles/TopNavStyle.css';
import { VscFeedback } from 'react-icons/vsc';
import { BsQuestionSquare } from 'react-icons/bs';
import { IoIosLogOut } from 'react-icons/io';
import { useAuthenticator } from '@aws-amplify/ui-react';

const TopNav: React.FC = () => {
  const { signOut } = useAuthenticator((context) => [context.route]);
  return (
    <div className="top-nav-container">
      <div className="top-nav-button-container">
        <BsQuestionSquare
          className="top-nav-helper-icon help"
          onClick={() =>
            window.open(
              'https://arsient.notion.site/Gu-a-de-producto-fe1d6a74776c46d6b45383af1445b621',
              '_blank'
            )
          }
        />
        <div className="top-nav-helper-icon-overlay help">Conce más</div>
        <VscFeedback
          className="top-nav-helper-icon feedback"
          onClick={() =>
            window.open('https://batuenergy.canny.io/bart', '_blank')
          }
        />
        <div className="top-nav-helper-icon-overlay feedback">
          Dános feedback
        </div>
        <IoIosLogOut
          className="top-nav-helper-icon exit"
          onClick={() => {
            if (signOut) {
              console.log('signing out');
              signOut();
            }
          }}
        />
        <div className="top-nav-helper-icon-overlay exit">Cerrar Sesión</div>
      </div>
    </div>
  );
};
export { TopNav };
